import { useState } from 'react';
import { HiDownload } from 'react-icons/hi';
import instance from "../../services/baseService";

const DownloadButton = ({ file, client_id, section }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    // Map section types to their respective API endpoints
    const getDownloadEndpoint = (sectionType) => {
        const endpoints = {
            'GSTR1': `/api/v1/client/download/file/${client_id}`,
            'REFUND': `/api/v1/client/refund/download/file/${client_id}`,
            'GSTR3B': `/api/v1/client/gstr3b/download/file/${client_id}`,
            'GSTR9': `/api/v1/client/gstr9/download/file/${client_id}`,
            'GSTR9C': `/api/v1/client/gstr9c/download/file/${client_id}`
        };

        return endpoints[sectionType?.toUpperCase()] || endpoints['GSTR1']; // Default fallback
    };

    const handleDownload = async (e) => {
        e.preventDefault();

        if (!file?.id || !client_id || !section) {
            console.error('Missing required parameters');
            return;
        }

        try {
            setIsDownloading(true);

            const endpoint = getDownloadEndpoint(section);
            const response = await instance.post(endpoint, { file_id: file.id });

            if (response.data?.type === 'success' && response.data?.data?.url) {
                const downloadUrl = response.data.data.url;

                const fileResponse = await fetch(downloadUrl);
                const blob = await fileResponse.blob();

                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = file.file_name || `${section.toLowerCase()}_file`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl); // Clean up
            } else {
                console.error('Invalid response from download API:', response.data);
            }
        } catch (error) {
            console.error(`Download failed for ${section}:`, error);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <button
            onClick={handleDownload}
            disabled={isDownloading}
            className={`bg-[#0f4372] rounded-[100%] text-white flex items-center justify-center p-1 transition-colors duration-200 ${isDownloading
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:bg-[#0a3458] active:bg-[#083048]'
                }`}
            title={`Download ${section} file`}
        >
            <HiDownload className={`text-lg ${isDownloading ? 'animate-pulse' : ''}`} />
        </button>
    );
};

export default DownloadButton;